import { BoringVaultV1Provider } from 'boring-vault-ui';
import { getValidChain, TChainId, vaultConfiguration } from 'modules/api';
import { useConnection } from 'modules/auth';
import { QueryLoading } from 'modules/common/components/QueryLoading';
import { ReactNode, useMemo } from 'react';
import { getVaultProviderOptions } from './utils/getVaultProviderOptions';
import { useVaultProvider } from './hooks/useVaultProvider';
import { BTC_DECIMALS } from 'modules/common/const';

interface IVaultContextProviderProps {
  children: ReactNode;
}

export function VaultContextProvider({
  children,
}: IVaultContextProviderProps): ReactNode {
  const { provider, readProvider } = useVaultProvider();

  const { chainId, isConnected, isLoading } = useConnection();

  const providerOptions = useMemo(
    () => getVaultProviderOptions(chainId as TChainId),
    [chainId],
  );

  const currentChainId = getValidChain(chainId);

  const getBoringVaultProvider = (ethersProvider: any) => (
    <BoringVaultV1Provider
      ethersProvider={ethersProvider}
      vaultContract={vaultConfiguration.vaultContract}
      tellerContract={vaultConfiguration.getTellerContract(currentChainId)}
      accountantContract={vaultConfiguration.getAccountantContract()}
      lensContract={vaultConfiguration.lensContract}
      withdrawQueueContract={vaultConfiguration.getWithdrawQueueContract()}
      baseAsset={vaultConfiguration.getBaseAsset(currentChainId)}
      vaultDecimals={BTC_DECIMALS}
      boringQueueContract={vaultConfiguration.boringQueueContract}
      {...providerOptions}
    >
      {children}
    </BoringVaultV1Provider>
  );

  if (provider && isConnected) {
    return getBoringVaultProvider(provider);
  }

  if (readProvider && !isConnected && !isLoading) {
    return getBoringVaultProvider(readProvider);
  }

  return <QueryLoading isAbsolute />;
}
